import {NodeConfig} from 'konva/lib/Node'
import {ElementTemplatesType, ElementType, ElementTypeId} from '../entities/elementType'
//import tree from 'url:/public/assets/patterns/plants/tree-27.svg'
import bush3 from 'url:/public/assets/patterns/plants/bush3.svg'
import bush4 from 'url:/public/assets/patterns/plants/bush4.svg'
import bush6 from 'url:/public/assets/patterns/plants/bush6.svg'
import bush7 from 'url:/public/assets/patterns/plants/bush7.svg'
//import redbush from 'url:/public/assets/patterns/plants/red_bush.svg'
import carex from 'url:/public/assets/patterns/plants/carex.svg'
import grass_gray from 'url:/public/assets/patterns/plants/grass_gray.svg'
//import bonsai3 from 'url:/public/assets/patterns/plants/bonsai3.svg'
import tree1 from 'url:/public/assets/patterns/plants/tree1.svg'
import treeapple from 'url:/public/assets/patterns/plants/tree_apple.svg'
import bushflowersorange from 'url:/public/assets/patterns/plants/bush_flowers_orange.svg'
import bushflowersred from 'url:/public/assets/patterns/plants/bush_flowers_red.svg'
import boxwoodball from 'url:/public/assets/patterns/plants/boxwood_ball.svg'
import cabbage from 'url:/public/assets/patterns/plants/fruits and vegetables/cabbage.svg'
import beet from 'url:/public/assets/patterns/plants/fruits and vegetables/beet.svg'
import carrot from 'url:/public/assets/patterns/plants/fruits and vegetables/carrot.svg'
import eggplant from 'url:/public/assets/patterns/plants/fruits and vegetables/eggplant.svg'
import onion from 'url:/public/assets/patterns/plants/fruits and vegetables/onion.svg'
import salad from 'url:/public/assets/patterns/plants/fruits and vegetables/salad.svg'
import dots2 from 'url:/public/assets/patterns/textures/dots-2.svg'
import shingles from 'url:/public/assets/patterns/textures/black-roof-tile-seamless-vector-background.svg'
import plantcomposition from 'url:/public/assets/patterns/textures/plant-composition.svg'
import water from 'url:/public/assets/patterns/textures/water.svg'
import softtiles from 'url:/public/assets/patterns/textures/soft-tiles-br.svg'
import flowerbed from 'url:/public/assets/patterns/textures/flower-bed.svg'
import garden from 'url:/public/assets/patterns/textures/garden.svg'
import vegetablegarden from 'url:/public/assets/patterns/textures/garden-bed.svg'
import tile from 'url:/public/assets/patterns/textures/garden-tiles.svg'
import stairs from 'url:/public/assets/patterns/textures/stairs.svg'
import terrace from 'url:/public/assets/patterns/textures/terrace.svg'
import court from 'url:/public/assets/patterns/textures/court-gray.svg'
import lawn from 'url:/public/assets/patterns/textures/lawn2.svg'
import hedge from 'url:/public/assets/patterns/textures/hedge.svg'
import greenhouse from 'url:/public/assets/patterns/textures/greenhouse.svg'
import pond1 from 'url:/public/assets/images/pond1.svg'
import building1 from 'url:/public/assets/patterns/buildings/house1.svg'
import building2 from 'url:/public/assets/patterns/buildings/house2.svg'
import building3 from 'url:/public/assets/patterns/buildings/house3.svg'
import building4 from 'url:/public/assets/patterns/buildings/house4.svg'
import building5 from 'url:/public/assets/patterns/buildings/house5.svg'
import building6 from 'url:/public/assets/patterns/buildings/house6.svg'
import building7 from 'url:/public/assets/patterns/buildings/house7.svg'
import building8 from 'url:/public/assets/patterns/buildings/house8.svg'
import building9 from 'url:/public/assets/patterns/buildings/house9.svg'
import building10 from 'url:/public/assets/patterns/buildings/house10.svg'
import building11 from 'url:/public/assets/patterns/buildings/house11.svg'
import building12 from 'url:/public/assets/patterns/buildings/house12.svg'
import building13 from 'url:/public/assets/patterns/buildings/house13.svg'
import building14 from 'url:/public/assets/patterns/buildings/house14.svg'
import building15 from 'url:/public/assets/patterns/buildings/house15.svg'
import building16 from 'url:/public/assets/patterns/buildings/house16.svg'
import building17 from 'url:/public/assets/patterns/buildings/house17.svg'
import building18 from 'url:/public/assets/patterns/buildings/house18.svg'
import gazebo1 from 'url:/public/assets/patterns/buildings/gazebo1.svg'
import pathway1 from 'url:/public/assets/patterns/pathway/pathway1.svg'
import pathway2 from 'url:/public/assets/patterns/pathway/pathway2.svg'
import pathway3 from 'url:/public/assets/patterns/pathway/pathway3.svg'
import pathway4 from 'url:/public/assets/patterns/pathway/pathway4.svg'
import pathway5 from 'url:/public/assets/patterns/pathway/pathway5.svg'
import pathway6 from 'url:/public/assets/patterns/pathway/pathway6.svg'
import pathway7 from 'url:/public/assets/patterns/pathway/pathway7.svg'
import pathway8 from 'url:/public/assets/patterns/pathway/pathway8.svg'
import pathway9 from 'url:/public/assets/patterns/pathway/pathway9.svg'
//import pathway10 from 'url:/public/assets/patterns/pathway/pathway10.svg'
import pathway11 from 'url:/public/assets/patterns/pathway/pathway11.svg'
import pathway12 from 'url:/public/assets/patterns/pathway/pathway12.svg'
import pathway13 from 'url:/public/assets/patterns/pathway/pathway13.svg'
import pathway14 from 'url:/public/assets/patterns/pathway/pathway14.svg'
//import waterpool1 from 'url:/public/assets/patterns/water/waterpool1.svg'
import waterpool2 from 'url:/public/assets/patterns/water/waterpool2.svg'
import waterpool3 from 'url:/public/assets/patterns/water/waterpool3.svg'
import waterpool4 from 'url:/public/assets/patterns/water/waterpool4.svg'
import waterpool5 from 'url:/public/assets/patterns/water/waterpool5.svg'
//import waterpool6 from 'url:/public/assets/patterns/water/waterpool6.svg'
//import waterpool7 from 'url:/public/assets/patterns/water/waterpool7.svg'
//import waterpool8 from 'url:/public/assets/patterns/water/waterpool8.svg'
//import waterpool9 from 'url:/public/assets/patterns/water/waterpool9.svg'
import fountain1 from 'url:/public/assets/patterns/water-other/fountain1.svg'
import waterfall1 from 'url:/public/assets/patterns/water-other/waterfall1.svg'
//import rockery1 from 'url:/public/assets/patterns/flowerbeds/rockery1.svg'
//import rockery2 from 'url:/public/assets/patterns/flowerbeds/rockery2.svg'
//import rockery3 from 'url:/public/assets/patterns/flowerbeds/rockery3.svg'
//import veggardencabbage1 from 'url:/public/assets/patterns/vegetablegarden/veg-garden-cabbage.svg'
import veggarden11 from 'url:/public/assets/patterns/vegetablegarden/veg-garden-1-1.svg'
import veggarden12 from 'url:/public/assets/patterns/vegetablegarden/veg-garden-1-2.svg'
//import veggarden2 from 'url:/public/assets/patterns/vegetablegarden/veg-garden-2.svg'
//import veggarden4 from 'url:/public/assets/patterns/vegetablegarden/veg-garden-4.svg'
//import veggarden7 from 'url:/public/assets/patterns/vegetablegarden/veg-garden-7.svg'
import veggarden26 from 'url:/public/assets/patterns/vegetablegarden/veg-garden-2-6.svg'
//import hedge1 from 'url:/public/assets/patterns/hedge/hedge1.svg'
import hedge2 from 'url:/public/assets/patterns/hedge/hedge2.svg'
import hedge3 from 'url:/public/assets/patterns/hedge/hedge3.svg'
//import hedge4 from 'url:/public/assets/patterns/hedge/hedge4.svg'
import hedge5 from 'url:/public/assets/patterns/hedge/hedge5.svg'
import hedge6 from 'url:/public/assets/patterns/hedge/hedge6.svg'
import tile1 from 'url:/public/assets/patterns/tile/tile1.svg'
import tile2 from 'url:/public/assets/patterns/tile/tile2.svg'
import tile3 from 'url:/public/assets/patterns/tile/tile3.svg'
import tile4 from 'url:/public/assets/patterns/tile/tile4.svg'
import tile5 from 'url:/public/assets/patterns/tile/tile5.svg'
import tile6 from 'url:/public/assets/patterns/tile/tile6.svg'
import stairs1 from 'url:/public/assets/patterns/stairs/stairs1.svg'
import stairs2 from 'url:/public/assets/patterns/stairs/stairs2.svg'
import flowerbed1 from 'url:/public/assets/patterns/flowerbeds/flowerbed1.svg'
import flowerbed2 from 'url:/public/assets/patterns/flowerbeds/flowerbed2.svg'
import flowerbed11 from 'url:/public/assets/patterns/flowerbeds/flowerbed11.svg'
import flowerbed22 from 'url:/public/assets/patterns/flowerbeds/flowerbed22.svg'
import terrace1 from 'url:/public/assets/patterns/terrace/terrace1.svg'
import court1 from 'url:/public/assets/patterns/court/court1.svg'
import court2 from 'url:/public/assets/patterns/court/court2.svg'
import patio1 from 'url:/public/assets/patterns/patio/patio1.svg'
import patio2 from 'url:/public/assets/patterns/patio/patio2.svg'
import fence1 from 'url:/public/assets/patterns/fence/fence1.svg'
import fence2 from 'url:/public/assets/patterns/fence/fence2.svg'
import fence3 from 'url:/public/assets/patterns/fence/fence3.svg'
import fence4 from 'url:/public/assets/patterns/fence/fence4.svg'
import gate1 from 'url:/public/assets/patterns/entrance/gate1.svg'
import gate2 from 'url:/public/assets/patterns/entrance/gate2.svg'
import wicket from 'url:/public/assets/patterns/entrance/wicket.svg'
import stone1 from 'url:/public/assets/patterns/other/stone1.svg'
import stone2 from 'url:/public/assets/patterns/other/stone2.svg'
import stone3 from 'url:/public/assets/patterns/other/stone3.svg'
import stone4 from 'url:/public/assets/patterns/other/stone4.svg'
import turtle from 'url:/public/assets/patterns/other/turtle.svg'
import car1 from 'url:/public/assets/patterns/other/car1.svg'
import flowerpot1 from 'url:/public/assets/patterns/other/flower-pot.svg'
import lampball from 'url:/public/assets/patterns/lighting/lamp-ball.svg'
import lamp from 'url:/public/assets/patterns/lighting/lamp.svg'
import spotlight from 'url:/public/assets/patterns/lighting/spotlight.svg'
//import garden1 from 'url:/public/assets/patterns/garden/garden1.svg'
import greenhouse1 from 'url:/public/assets/patterns/greenhouse/greenhouse1.svg'
import table1 from 'url:/public/assets/patterns/furniture/table.svg'
import sofa1 from 'url:/public/assets/patterns/furniture/sofa.svg'
import chair1 from 'url:/public/assets/patterns/furniture/chair.svg'

const baseTemplate = 'tree1'

export class ElementTypeService {
  private elementTypes: Record<ElementTypeId, Omit<ElementType, 'id'>> = {
    building: {
      displayName: 'building',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: shingles,
        shadowBlur: 200,
      }),
      templates: {
        building1: {width: 1400, height: 700, src: building1, name: 'building 1'},
        building2: {width: 1150, height: 650, src: building2, name: 'building 2'},
        building3: {width: 1400, height: 900, src: building3, name: 'building 3'},
        building4: {width: 815, height: 805, src: building4, name: 'building 4'},
        building5: {width: 780, height: 780, src: building5, name: 'building 5'},
        building6: {width: 915, height: 1770, src: building6, name: 'building 6'},
        building7: {width: 1630, height: 290, src: building7, name: 'building 7'},
        building8: {width: 1645, height: 1300, src: building8, name: 'building 8'},
        building9: {width: 1400, height: 720, src: building9, name: 'building 9'},
        building10: {width: 1150, height: 860, src: building10, name: 'building 10'},
        building11: {width: 1150, height: 660, src: building11, name: 'building 11'},
        building12: {width: 900, height: 900, src: building12, name: 'building 12'},
        building13: {width: 1150, height: 660, src: building13, name: 'building 13'},
        building14: {width: 990, height: 990, src: building14, name: 'building 14'},
        building15: {width: 1580, height: 1260, src: building15, name: 'building 15'},
        building16: {width: 1580, height: 820, src: building16, name: 'building 16'},
        building17: {width: 1400, height: 720, src: building17, name: 'building 17'},
        building18: {width: 1310, height: 1280, src: building18, name: 'building 18'},
      },
      zIndex: 150,
    },
    garden: {
      displayName: 'garden',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: garden,
        shadowBlur: 100,
      }),
      // templates: {
      //   garden1: {width: 1600, height: 800, src: garden1, name: 'garden 1'},
      // },
      zIndex: 120,
    },
    lawn: {
      displayName: 'lawn',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: lawn,
      }),
      zIndex: 20,
    },

    flowerbed: {
      displayName: 'flowerbed',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: flowerbed,
        stroke: '#aadd98ad',
        strokeWidth: 50,
      }),
      templates: {
        flowerbed1: {width: 400, height: 400, src: flowerbed1, name: 'flowerbed 1'},
        flowerbed2: {width: 400, height: 400, src: flowerbed2, name: 'flowerbed 2'},
        flowerbed11: {width: 400, height: 400, src: flowerbed11, name: 'flowerbed 11'},
        flowerbed22: {width: 400, height: 400, src: flowerbed22, name: 'flowerbed 22'},
      },
      zIndex: 30,
    },
    greenhouse: {
      displayName: 'greenhouse',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: greenhouse,
      }),
      templates: {
        greenhouse1: {width: 1000, height: 300, src: greenhouse1, name: 'greenhouse 1'},
      },
      zIndex: 40,
    },

    vegetablegarden: {
      displayName: 'vegetablegarden',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: vegetablegarden,
        stroke: '#997361cc',
        strokeWidth: 50,
      }),
      templates: {
        //veggardencabbage: {width: 80, height: 188, src: veggardencabbage1, name: 'cabbage 1'},
        veggarden11: {width: 80, height: 188, src: veggarden11, name: 'veg garden 11'},
        veggarden12: {width: 80, height: 188, src: veggarden12, name: 'veg garden 12'},
        //veggarden2: {width: 300, height: 50, src: veggarden2, name: 'veg garden 2'},
        //veggarden4: {width: 300, height: 100, src: veggarden4, name: 'veg garden 4'},
        //veggarden7: {width: 300, height: 175, src: veggarden7, name: 'veg garden 7'},
        veggarden26: {width: 600, height: 200, src: veggarden26, name: 'veg garden 26'},
      },
      zIndex: 30,
    },
    tile: {
      displayName: 'tile',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: tile,
      }),
      templates: {
        tile1: {width: 600, height: 300, src: tile1, name: 'tile 1'},
        tile2: {width: 500, height: 350, src: tile2, name: 'tile 2'},
        tile3: {width: 400, height: 300, src: tile3, name: 'tile 3'},
        tile4: {width: 370, height: 310, src: tile4, name: 'tile 4'},
        tile5: {width: 320, height: 320, src: tile5, name: 'tile 5'},
        tile6: {width: 330, height: 330, src: tile6, name: 'tile 6'},
      },
      zIndex: 20,
    },
    stairs: {
      displayName: 'stairs',
      availableShapeTypes: ['rect', 'polygon'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: stairs,
      }),
      templates: {
        stairs1: {width: 100, height: 200, src: stairs1, name: 'stairs 1'},
        stairs2: {width: 150, height: 150, src: stairs2, name: 'stairs 2'},
      },
      zIndex: 20,
    },
    terrace: {
      displayName: 'terrace',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: terrace,
      }),
      templates: {
        terrace1: {width: 500, height: 300, src: terrace1, name: 'terrace 1'},
      },
      zIndex: 20,
    },
    fence: {
      displayName: 'fence',
      availableShapeTypes: ['rect', 'polygon'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: 'gray',
        fillPatternImage: '',
      }),
      templates: {
        fence1: {width: 430, height: 31, src: fence1, name: 'fence 1'},
        fence2: {width: 655, height: 27, src: fence2, name: 'fence 2'},
        fence3: {width: 320, height: 35, src: fence3, name: 'fence 3'},
        fence4: {width: 210, height: 28, src: fence4, name: 'fence 4'},
      },
      zIndex: 80,
    },
    entrance: {
      displayName: 'entrance',
      availableShapeTypes: ['rect'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: 'gray',
        fillPatternImage: '',
      }),
      templates: {
        gate1: {width: 400, height: 30, src: gate1, name: 'gate 1'},
        gate2: {width: 300, height: 30, src: gate2, name: 'gate 2'},
        wicket: {width: 120, height: 20, src: wicket, name: 'wicket'},
      },
      zIndex: 80,
    },
    // tree: {
    //   displayName: 'tree',
    //   availableShapeTypes: ['ellipse'],
    //   getShapeFromDisplayProps: (displayProps: NodeConfig) => {
    //     const imageHeight = 300
    //     const imageWidth = 300

    //     return {
    //       fill: '',
    //       fillPatternImage: tree1,
    //       fillPatternRepeat: 'no-repeat',
    //       fillPatternScale: {
    //         x: (2 * displayProps.radiusX) / imageWidth,
    //         y: (2 * displayProps.radiusY) / imageHeight,
    //       },
    //       fillPatternOffset: {x: imageWidth / 2, y: imageHeight / 2},
    //     }
    //   },
    // },
    plantcomposition: {
      displayName: 'plantcomposition',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: plantcomposition,
      }),
      // templates: {
      //   rockery1: {width: 362, height: 207, src: rockery1, name: 'rockery 1'},
      //   rockery2: {width: 296, height: 165, src: rockery2, name: 'rockery 2'},
      //   rockery3: {width: 312, height: 307, src: rockery3, name: 'rockery 3'},
      // },
      zIndex: 50,
    },
    plot: {
      displayName: '',
      availableShapeTypes: ['rect', 'polygon'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => {
        return {
          fill: '',
          fillPatternImage: dots2,
        }
      },
      zIndex: 0,
    },
    plant: {
      displayName: 'solitarius',
      availableShapeTypes: ['image'],
      templates: {
        tree1: {width: 300, height: 300, src: tree1, name: 'tree'},
        treeapple: {width: 300, height: 300, src: treeapple, name: 'apple tree'},
        bush3: {width: 100, height: 100, src: bush3, name: 'bush'},
        bush4: {width: 100, height: 100, src: bush4, name: 'bush'},
        bush6: {width: 100, height: 100, src: bush6, name: 'bush'},
        bush7: {width: 100, height: 100, src: bush7, name: 'bush'},
        //redBush: {width: 100, height: 100, src: redbush, name: 'red bush'},
        grass_gray: {width: 100, height: 100, src: grass_gray, name: 'grass'},
        //bonsai3: {width: 100, height: 100, src: bonsai3, name: 'bonsai3'},
        carex: {width: 50, height: 50, src: carex, name: 'carex'},
        bushflowersorange: {width: 100, height: 100, src: bushflowersorange, name: 'bush'},
        bushflowersred: {width: 100, height: 100, src: bushflowersred, name: 'bush'},
        boxwoodball: {width: 50, height: 50, src: boxwoodball, name: 'boxwood'},
        cabbage: {width: 40, height: 40, src: cabbage, name: 'cabbage'},
        carrot: {width: 5, height: 30, src: carrot, name: 'carrot'},
        eggplant: {width: 22, height: 49, src: eggplant, name: 'eggplant'},
        beet: {width: 36, height: 35, src: beet, name: 'beet'},
        onion: {width: 14, height: 66, src: onion, name: 'onion'},
        salad: {width: 18, height: 26, src: salad, name: 'salad'},
      },
      getShapeFromDisplayProps: (displayProps: NodeConfig) => {
        const imageHeight = 150
        const imageWidth = 150

        return {
          x: displayProps.x,
          y: displayProps.y,
          // fill: 'red',
          fillPatternImage: bush4,
          fillPatternRepeat: 'no-repeat',
          fillPatternScale: {
            x: 80 / imageWidth,
            y: 80 / imageHeight,
          },
          radiusX: imageWidth,
          radiusY: imageHeight,
          fillPatternOffset: {x: imageWidth / 2, y: imageHeight / 2},
        }
      },
      zIndex: 50,
    },
    tree: {
      displayName: 'treeCat',
      availableShapeTypes: ['image'],
      templates: {
        tree1: {width: 300, height: 300, src: tree1, name: 'tree'},
        treeapple: {width: 300, height: 300, src: treeapple, name: 'apple tree'},
      },
      getShapeFromDisplayProps: (displayProps: NodeConfig) => {
        const imageHeight = 150
        const imageWidth = 150

        return {
          x: displayProps.x,
          y: displayProps.y,
          // fill: 'red',
          fillPatternImage: bush4,
          fillPatternRepeat: 'no-repeat',
          fillPatternScale: {
            x: 80 / imageWidth,
            y: 80 / imageHeight,
          },
          radiusX: imageWidth,
          radiusY: imageHeight,
          fillPatternOffset: {x: imageWidth / 2, y: imageHeight / 2},
        }
      },
      zIndex: 50,
    },
    bush: {
      displayName: 'bushCat',
      availableShapeTypes: ['image'],
      templates: {
        bush3: {width: 100, height: 100, src: bush3, name: 'bush'},
        bush4: {width: 100, height: 100, src: bush4, name: 'bush'},
        bush6: {width: 100, height: 100, src: bush6, name: 'bush'},
        bush7: {width: 100, height: 100, src: bush7, name: 'bush'},
        //redBush: {width: 100, height: 100, src: redbush, name: 'red bush'},
        grass_gray: {width: 100, height: 100, src: grass_gray, name: 'grass'},
        //bonsai3: {width: 100, height: 100, src: bonsai3, name: 'bonsai3'},
        carex: {width: 50, height: 50, src: carex, name: 'carex'},
        bushflowersorange: {width: 100, height: 100, src: bushflowersorange, name: 'bush'},
        bushflowersred: {width: 100, height: 100, src: bushflowersred, name: 'bush'},
        boxwoodball: {width: 50, height: 50, src: boxwoodball, name: 'boxwood'},
      },
      getShapeFromDisplayProps: (displayProps: NodeConfig) => {
        const imageHeight = 150
        const imageWidth = 150

        return {
          x: displayProps.x,
          y: displayProps.y,
          // fill: 'red',
          fillPatternImage: bush4,
          fillPatternRepeat: 'no-repeat',
          fillPatternScale: {
            x: 80 / imageWidth,
            y: 80 / imageHeight,
          },
          radiusX: imageWidth,
          radiusY: imageHeight,
          fillPatternOffset: {x: imageWidth / 2, y: imageHeight / 2},
        }
      },
      zIndex: 50,
    },
    flower: {
      displayName: 'flowerCat',
      availableShapeTypes: ['image'],
      templates: {
        bushflowersorange: {width: 100, height: 100, src: bushflowersorange, name: 'bush'},
        bushflowersred: {width: 100, height: 100, src: bushflowersred, name: 'bush'},
      },
      getShapeFromDisplayProps: (displayProps: NodeConfig) => {
        const imageHeight = 150
        const imageWidth = 150

        return {
          x: displayProps.x,
          y: displayProps.y,
          // fill: 'red',
          fillPatternImage: bush4,
          fillPatternRepeat: 'no-repeat',
          fillPatternScale: {
            x: 80 / imageWidth,
            y: 80 / imageHeight,
          },
          radiusX: imageWidth,
          radiusY: imageHeight,
          fillPatternOffset: {x: imageWidth / 2, y: imageHeight / 2},
        }
      },
      zIndex: 50,
    },
    vegetable: {
      displayName: 'vegetableCat',
      availableShapeTypes: ['image'],
      templates: {
        cabbage: {width: 40, height: 40, src: cabbage, name: 'cabbage'},
        carrot: {width: 5, height: 30, src: carrot, name: 'carrot'},
        eggplant: {width: 22, height: 49, src: eggplant, name: 'eggplant'},
        beet: {width: 36, height: 35, src: beet, name: 'beet'},
        onion: {width: 14, height: 66, src: onion, name: 'onion'},
        salad: {width: 18, height: 26, src: salad, name: 'salad'},
      },
      getShapeFromDisplayProps: (displayProps: NodeConfig) => {
        const imageHeight = 150
        const imageWidth = 150

        return {
          x: displayProps.x,
          y: displayProps.y,
          // fill: 'red',
          fillPatternImage: bush4,
          fillPatternRepeat: 'no-repeat',
          fillPatternScale: {
            x: 80 / imageWidth,
            y: 80 / imageHeight,
          },
          radiusX: imageWidth,
          radiusY: imageHeight,
          fillPatternOffset: {x: imageWidth / 2, y: imageHeight / 2},
        }
      },
      zIndex: 50,
    },
    structure: {
      displayName: 'structure',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: softtiles,
        shadowBlur: 200,
      }),
      templates: {
        gazebo1: {width: 540, height: 540, src: gazebo1, name: 'gazebo 1'},
      },
      zIndex: 150,
    },
    pathway: {
      displayName: 'pathway',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: tile,
      }),
      templates: {
        pathway1: {width: 100, height: 250, src: pathway1, name: 'pathway 1'},
        pathway2: {width: 230, height: 230, src: pathway2, name: 'pathway 2'},
        pathway3: {width: 230, height: 250, src: pathway3, name: 'pathway 3'},
        pathway4: {width: 100, height: 250, src: pathway4, name: 'pathway 4'},
        pathway5: {width: 230, height: 230, src: pathway5, name: 'pathway 5'},
        pathway6: {width: 230, height: 250, src: pathway6, name: 'pathway 6'},
        pathway7: {width: 100, height: 250, src: pathway7, name: 'pathway 7'},
        pathway8: {width: 230, height: 230, src: pathway8, name: 'pathway 8'},
        pathway9: {width: 230, height: 250, src: pathway9, name: 'pathway 9'},
        //pathway10: {width: 300, height: 300, src: pathway10, name: 'pathway 10'},
        pathway11: {width: 350, height: 100, src: pathway11, name: 'pathway 11'},
        pathway12: {width: 1500, height: 300, src: pathway12, name: 'pathway 12'},
        pathway13: {width: 1500, height: 300, src: pathway13, name: 'pathway 13'},
        pathway14: {width: 300, height: 100, src: pathway14, name: 'pathway 14'},
      },
      zIndex: 20,
    },
    court: {
      displayName: 'court',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: court,
      }),
      templates: {
        court1: {width: 1620, height: 900, src: court1, name: 'court 1'},
        court2: {width: 1620, height: 900, src: court2, name: 'court 2'},
      },
      zIndex: 20,
    },
    patio: {
      displayName: 'patio',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: tile6,
      }),
      templates: {
        patio1: {width: 300, height: 300, src: patio1, name: 'patio 1'},
        patio2: {width: 300, height: 300, src: patio2, name: 'patio 2'},
      },
      zIndex: 40,
    },
    hedge: {
      displayName: 'hedge',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: hedge,
      }),
      templates: {
        //hedge1: {width: 240, height: 70, src: hedge1, name: 'hedge 1'},
        hedge2: {width: 80, height: 210, src: hedge2, name: 'hedge 2'},
        hedge3: {width: 100, height: 84, src: hedge3, name: 'hedge 3'},
        //hedge4: {width: 300, height: 50, src: hedge4, name: 'hedge 4'},
        hedge5: {width: 650, height: 50, src: hedge5, name: 'hedge 5'},
        hedge6: {width: 350, height: 50, src: hedge6, name: 'hedge 6'},
      },
      zIndex: 40,
    },
    pool: {
      displayName: 'pool',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: water,
        stroke: '#9cd3db',
        strokeWidth: 50,
      }),
      templates: {
        //waterpool1: {width: 366, height: 297, src: waterpool1, name: 'waterpool 1'},
        waterpool2: {width: 240, height: 240, src: waterpool2, name: 'waterpool 2'},
        waterpool3: {width: 400, height: 500, src: waterpool3, name: 'waterpool 3'},
        waterpool5: {width: 330, height: 200, src: waterpool5, name: 'waterpool 5'},
        waterpool4: {width: 400, height: 200, src: waterpool4, name: 'waterpool 4'},
        //waterpool6: {width: 380, height: 500, src: waterpool6, name: 'waterpool 6'},
        //waterpool7: {width: 400, height: 400, src: waterpool7, name: 'waterpool 7'},
        //waterpool8: {width: 400, height: 400, src: waterpool8, name: 'waterpool 8'},
        //waterpool9: {width: 272, height: 200, src: waterpool9, name: 'waterpool 9'},
      },
      zIndex: 40,
    },
    water: {
      displayName: 'water',
      availableShapeTypes: ['rect', 'polygon', 'ellipse'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: water,
        stroke: '#9cd3db',
        strokeWidth: 50,
      }),
      templates: {
        fountain1: {width: 100, height: 100, src: fountain1, name: 'fountain 1'},
        waterfall1: {width: 200, height: 200, src: waterfall1, name: 'waterfall 1'},
      },
      zIndex: 40,
    },
    furniture: {
      displayName: 'furniture',
      availableShapeTypes: ['image'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: stone1,
      }),
      templates: {
        sofa1: {width: 200, height: 100, src: sofa1, name: 'sofa'},
        table1: {width: 100, height: 100, src: table1, name: 'table'},
        chair1: {width: 100, height: 100, src: chair1, name: 'chair'},
      },
      zIndex: 40,
    },
    lighting: {
      displayName: 'lighting',
      availableShapeTypes: ['image'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: stone1,
      }),
      templates: {
        lampball: {width: 50, height: 50, src: lampball, name: 'lamp ball'},
        lamp: {width: 50, height: 50, src: lamp, name: 'lamp'},
        spotlight: {width: 40, height: 40, src: spotlight, name: 'spotlight'},
      },
      zIndex: 40,
    },
    other: {
      displayName: 'other',
      availableShapeTypes: ['image'],
      getShapeFromDisplayProps: (displayProps: NodeConfig) => ({
        fill: '',
        fillPatternImage: stone1,
      }),
      templates: {
        stone1: {width: 100, height: 100, src: stone1, name: 'stone 1'},
        stone2: {width: 100, height: 100, src: stone2, name: 'stone 2'},
        stone3: {width: 100, height: 100, src: stone3, name: 'stone 3'},
        stone4: {width: 100, height: 100, src: stone4, name: 'stone 4'},
        flowerpot1: {width: 40, height: 30, src: flowerpot1, name: 'flower pot'},
        turtle: {width: 50, height: 50, src: turtle, name: 'turtle'},
        car1: {width: 320, height: 170, src: car1, name: 'car'},
      },
      zIndex: 40,
    },
  }

  getElementTypes(): ElementType[] {
    return Object.entries(this.elementTypes).map(([key, value]) => ({
      id: key as ElementTypeId,
      ...value,
    }))
  }

  chooseElementTypeTemplate(elementTypeId: ElementTypeId, templateId: string) {
    if (!templateId) {
      return baseTemplate
    }

    return this.elementTypes[elementTypeId].templates[templateId] ? templateId : baseTemplate
  }

  getElementType(id: ElementTypeId): ElementType | null {
    if (!this.elementTypes[id]) {
      return null
    }

    return {
      id,
      ...this.elementTypes[id],
    }
  }

  getSectorElementTypes(): ElementTypeId[] {
    return [
      'flowerbed',
      'garden',
      'lawn',
      'vegetablegarden',
      'plantcomposition',
      'hedge',
      'plant',
      'greenhouse',
    ]
  }

  getBuildingsElementTypes(): ElementTypeId[] {
    return ['building', 'structure', 'fence', 'entrance', 'hedge']
  }

  getHardscapeElementTypes(): ElementTypeId[] {
    return ['pathway', 'terrace', 'tile', 'stairs', 'court', 'patio']
  }

  getWaterscapeElementTypes(): ElementTypeId[] {
    return ['pool', 'water']
  }

  getPlantsElementTypes(): ElementTypeId[] {
    return ['tree']
  }

  getSolitariusElementTypes(): ElementTypeId[] {
    return ['tree', 'bush', 'flower', 'vegetable']
  }

  getOtherElementTypes(): ElementTypeId[] {
    return ['furniture', 'lighting', 'other']
  }

  getElementTypeTemplates(id: ElementTypeId): ElementTemplatesType | null {
    if (!this.elementTypes[id]) {
      return null
    }

    return this.elementTypes[id].templates
  }
}

export const instance = new ElementTypeService()
